export function slugify(input: string): string {
  return input
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .trim();
}

export function normalizeQuerySlug(value: string | null | undefined): string | null {
  if (!value) return null;
  const decoded = value.trim();
  if (!decoded) return null;
  return slugify(decoded);
}